import $ from 'jquery';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import cn from 'classnames';
import 'bootstrap-daterangepicker/daterangepicker.css';

import './brDatePicker.scss';

const startOfToday = moment().startOf('day');
const getValidDate = (momentDate) => (momentDate && moment(momentDate).isValid() ? moment(momentDate) : startOfToday);

export default class BrDatePicker extends PureComponent {
  static propTypes = {
    minDate: PropTypes.any,
    maxDate: PropTypes.any,
    startDate: PropTypes.any,
    timePicker: PropTypes.bool,
    open: PropTypes.oneOf(['left', 'right', 'center']),
    onApply: PropTypes.func.isRequired,
    parent: PropTypes.any,
    disabled: PropTypes.bool,
    title: PropTypes.any,
    drops: PropTypes.oneOf(['down', 'up', 'auto']),
    pickerIcon: PropTypes.element,
  };

  static defaultProps = {
    timePicker: true,
    onApply: null,
    open: 'left',
    drops: 'auto',
  };

  constructor(props) {
    super(props);
    this.state = {
      minDate: getValidDate(this.props.minDate),
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (getValidDate(nextProps.minDate).valueOf() !== getValidDate(this.props.minDate).valueOf()) {
      this.setState({
        minDate: getValidDate(nextProps.minDate),
      });
    }
  }

  setTimeLocale() {
    const zoneAbbr = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
    const timeZone = $(`<span class="time-zone"> ${zoneAbbr} </span>`);
    this.find('.calendar-time i').remove();
    if (!this.find('.left .calendar-time span').length) {
      this.find('.left .calendar-time .ampmselect').after(timeZone);
    }
    if (!this.find('.right .calendar-time span').length) {
      this.find('.right .calendar-time .ampmselect').after(timeZone);
    }
  }

  handleShowCalendar = (e, picker) => {
    const { container } = picker;
    if (e.type === 'show') {
      container.find('.calendar').on('DOMNodeInserted', this.setTimeLocale.bind(container));
      this.setTimeLocale.bind(container)();
    } else {
      container.find('.calendar').off('DOMNodeInserted');
    }
  };

  handleApplyDateRange(e, picker) {
    this.props.onApply(picker.startDate._d);
  }

  render() {
    const {
      open,
      minDate,
      maxDate,
      timePicker,
      timePicker24Hour,
      className,
      disabled,
      title,
      drops,
      startDate,
      pickerIcon,
    } = this.props;
    const buttonClassName = cn('br-button', className, disabled ? 'disabled' : '');
    const singleDatePickerInitialSettings = {
      minDate: minDate ? moment(minDate) : moment(new Date(0)),
      maxDate: maxDate ? moment(maxDate) : moment(new Date(9999, 11, 31)),
      opens: open,
      timePicker,
      singleDatePicker: true,
      timePicker24Hour,
      drops,
      startDate,
    };
    return (
      <DateRangePicker
        initialSettings={singleDatePickerInitialSettings}
        onApply={this.handleApplyDateRange.bind(this)}
        onEvent={this.handleShowCalendar}
        data-id="br-date-picker"
      >
        <div>
          {pickerIcon || <button className={buttonClassName} disabled={disabled}>{title}</button>}
        </div>
      </DateRangePicker>
    );
  }
}
